import React, { useState, useEffect } from 'react';
import './ChangePasswordPage.scss';
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
import CustomChangePassword from "../../forms/CustomChangePassword/CustomChangePassword";
import Hero from "../../common/Hero/Hero";
import Modal from "../../common/Modal/Modal";

const ChangePasswordPage = () => {  
    
    const {t} = useTranslation();
    const location = useLocation();
    const [infoModal, setInfoModal] = useState(false);
    useEffect(() => {
      if(location?.state?.passwordExpiration) {
        return setInfoModal( true)
      }
    },[location])

  const closeModal = () => {
      location.state.passwordExpiration = false
      setInfoModal(false)
  }
    return(
        <div className="ChangePasswordPage" data-testid="ChangePasswordPage">
            <Hero backTo={'/'}
                  backToText={t("common.back.home")}
                  title={t("change.password.header")}
                description={t('change.password.description')} />
          {location?.state?.passwordExpiration ?
          <Modal
            description={t("password.expiration.info.message")}
            show={infoModal}
            type={"button"}
            onClose={() => closeModal()}
            onFirstClick={() => closeModal()}
            linkTitle={t("common.hoCapito")}
          /> : <div className="container page-content-container">
            <CustomChangePassword/>
          </div>}
        </div>
    );
}

ChangePasswordPage.propTypes = {};

export default ChangePasswordPage;
